import React from 'react'
import PropTypes from 'prop-types';
import StageFinish from "./StageFinish";

function Index(
    {
        expanded,
    }) {

    return (expanded && <StageFinish />)
}

Index.propTypes = {
    classes: PropTypes.any,
}

export default Index;